import { IDevice } from "./IDevice";

export class device_api {

    public static get_devices_short:string = "/api/device/get_devices_short"
    public static find_by_id:string = "/api/device/find_by_id"
    public static create:string = "/api/device/create"
    public static update:string = "/api/device/update"
    public static delete:string = "/api/device/delete"
    public static get_maszyny="/api/device/get_maszyny"
    
}

export interface IDeviceSvc {
    get_devices_short(limit:number): Promise<IDevice[] | undefined> 
    find_by_id(_id: any): Promise<IDevice | undefined> 
    create(device:IDevice): Promise<IDevice | undefined> 
    update(device:IDevice): Promise<IDevice | undefined> 
    delete(device:IDevice): Promise<IDevice | undefined> 
    get_maszyny(): Promise<IDevice[]>
}